import { render, staticRenderFns } from "./InputRichTextCpt.vue?vue&type=template&id=4e96f925&"
import script from "./InputRichTextCpt.vue?vue&type=script&lang=ts&"
export * from "./InputRichTextCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputRichTextCpt.vue?vue&type=style&index=0&id=4e96f925&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports